import React from 'react';
import { Box, Container, Tab, Tabs } from '@mui/material';
import IncomeManagement from './IncomeManagement';
import ExpenseManagement from './ExpenseManagement';
import UnassignedTransactions from './UnassignedTransactions';
import AssignedTransactions from './AssignedTransactions';

const TAB_ITEMS = [
    { value: 'incomes', label: 'Einnahmen' },
    { value: 'expenses', label: 'Ausgaben' },
    { value: 'unassigned', label: 'Nicht zugeordnete Vorgänge' },
    { value: 'assigned', label: 'Zugeordnete Vorgänge' },
];

const resolveTab = (value) => (
    TAB_ITEMS.some((item) => item.value === value) ? value : 'incomes'
);

const TabPanel = ({ active, children }) => (
    <Box
        role="tabpanel"
        hidden={!active}
        sx={{ display: active ? 'block' : 'none' }}
    >
        {children}
    </Box>
);

export default function PaymentTransactions({ initialTab = 'incomes' }) {
    const [tab, setTab] = React.useState(() => resolveTab(initialTab));
    const [mountedTabs, setMountedTabs] = React.useState(() => new Set([resolveTab(initialTab)]));

    React.useEffect(() => {
        const nextTab = resolveTab(initialTab);
        setTab((prev) => (prev === nextTab ? prev : nextTab));
    }, [initialTab]);

    React.useEffect(() => {
        setMountedTabs((prev) => {
            if (prev.has(tab)) {
                return prev;
            }
            const next = new Set(prev);
            next.add(tab);
            return next;
        });
    }, [tab]);

    const handleTabChange = (_event, value) => {
        setTab(value);
    };

    return (
        <Box>
            <Box sx={{ borderBottom: 1, borderColor: 'divider', backgroundColor: 'background.paper' }}>
                <Container maxWidth="lg">
                    <Tabs
                        value={tab}
                        onChange={handleTabChange}
                        variant="scrollable"
                        scrollButtons="auto"
                    >
                        {TAB_ITEMS.map((item) => (
                            <Tab key={item.value} value={item.value} label={item.label} />
                        ))}
                    </Tabs>
                </Container>
            </Box>
            <Box>
                {mountedTabs.has('incomes') && (
                    <TabPanel active={tab === 'incomes'}>
                        <IncomeManagement />
                    </TabPanel>
                )}
                {mountedTabs.has('expenses') && (
                    <TabPanel active={tab === 'expenses'}>
                        <ExpenseManagement />
                    </TabPanel>
                )}
                {mountedTabs.has('unassigned') && (
                    <TabPanel active={tab === 'unassigned'}>
                        <UnassignedTransactions />
                    </TabPanel>
                )}
                {mountedTabs.has('assigned') && (
                    <TabPanel active={tab === 'assigned'}>
                        <AssignedTransactions />
                    </TabPanel>
                )}
            </Box>
        </Box>
    );
}
